import moment from "moment";

const AppUtils = {
  renderNumber(value, isConvertToLocalString) {
    if (!value) return 0;
    if (isConvertToLocalString) {
      return parseFloat(value).toLocaleString();
    }
    return value;
  },

  convertToKoreaPhoneNumber(value) {
    if (!value) return;
    let dashAfterFirstNumber = 3;
    let dashAfterSecondNumber = 7;
    const maximum = 11;
    const numericValue = value.replace(/\D/g, "");
    let formattedPhoneNumber = numericValue;
    if (
      numericValue.length >= dashAfterFirstNumber &&
      numericValue.length < dashAfterSecondNumber
    ) {
      formattedPhoneNumber = `${numericValue.slice(
        0,
        dashAfterFirstNumber
      )}-${numericValue.slice(dashAfterFirstNumber)}`;
    } else if (
      numericValue.length >= dashAfterSecondNumber &&
      numericValue.length < maximum + 1
    ) {
      formattedPhoneNumber = `${numericValue.slice(
        0,
        dashAfterFirstNumber
      )}-${numericValue.slice(
        dashAfterFirstNumber,
        dashAfterSecondNumber
      )}-${numericValue.slice(dashAfterSecondNumber)}`;
    }

    return formattedPhoneNumber;
  },

  formatToKoreaDate(date) {
    if (!date) return "";
    return moment(date).format("YYYY년 MM월 DD일");
  },


  formatDate(date, type) {
    if (!date) return "";
    return moment(date).format(type);
  },

  replaceDash(value) {
    if (!value) return "";
    return value.replace(/-/g, "")
  },
  getCommentFailMessage(input){
    if (input !== null) {
      if (input?.includes('(') && input?.includes(')')) {
        let tmp = input?.split('(')[1];
        return tmp.replace(')', '');
      }
      return input;
    }
  }
};

export default AppUtils;
